export default __webpack_public_path__ + "static/media/froehlichSOs.14684ab7.jpg";